export const API_URL = 'https://api.wrios.com/api/'
export const CLIENT_ID = 2
export const GA_TRACKING_ID = 'UA-177609049-1'
